import isEmpty from 'lodash/isEmpty'
import { BookListItem } from '@fable/types'

export const EMPTY_BOOK_LIST_ITEM: BookListItem = {
  name: '',
  description: '',
  id: '',
  type: '',
  cover_image: '',
  background_color: '',
  updated_at: '',
  count: 0,
  url: '',
  privacy: '',
  user_uuid: '',
}

export const getBookListsWithAction = (
  lists: BookListItem[],
  isAuthUser: boolean
): BookListItem[] => {
  const addNewItem: BookListItem = {
    ...EMPTY_BOOK_LIST_ITEM,
    name: 'New list',
    description: 'Add your favorite books',
  }

  if (!isEmpty(lists) && isAuthUser) lists.unshift(addNewItem)

  return lists
}
